import React from 'react';
import classNames from 'classnames';

import Utility from '../../../../../util/utilityfunctions';
import {labels} from '../../../../../util/utils';

import {BarChart} from '@ey/canvascoreservices/Charts';
import OutputText from '@ey/canvascoreservices/OutputText';

import Tile from '../../../../Common/Tile';
import StyledCount from './StyledCount';

const TaskAssignmentChart = ({
	tileHeading,
	tileSubHeading,
	isDataAvailable,
	noDataAvailableMessage,
	barChartData,
	assignedCount,
	assignedLabel,
	unassignedCount,
	unassignedLabel,
	unassignedLabelClickHandler,
	onGraphicClick,
	filterKey
}) => {
	const renderCount = (count, label, onClick = null) => {
		const props = {};
		if (onClick) props.onClick = onClick;
		return (
			<StyledCount>
				<OutputText h3 title={count}>
					{count}
				</OutputText>
				<OutputText body3 title={label} className={classNames('grey', {clickable: !!onClick})} {...props}>
					{label}
				</OutputText>
			</StyledCount>
		);
	};

	const tileProps = {
		title: tileHeading,
		subTitle: tileSubHeading,
		isEmpty: !isDataAvailable,
		emptyTitle: labels.thereIsNoDataToDisplay,
		emptySubtitle: labels.selectadditionalEntitiesToContinue
	};

	const chartProps = {
		chartType: 'barChart',
		chartData: barChartData,
		theme: document.getElementsByTagName('body')[0].getAttribute('motif-theme') === 'dark' ? 'dark' : null,
		onGraphicClick: (e) => {
			const serie = e.point.series.userOptions.toolTip.split('|')?.[0]?.trim() || '';
			onGraphicClick(serie, filterKey);
		},
		onOverdueClick: (serie) => onGraphicClick(serie, filterKey),
		serieSuffix: ` ${labels.overdue}`
	};

	return (
		<Tile {...tileProps}>
			{renderCount(assignedCount, Utility.removeTags(assignedLabel))}
			<BarChart {...chartProps} />
			{renderCount(unassignedCount, Utility.createRichTextElement(unassignedLabel), unassignedLabelClickHandler)}
		</Tile>
	);
};

export default TaskAssignmentChart;
